import "./index.css";
import React from "react";
import ReactDOM from "react-dom/client";
import { App } from "./App";
import { site } from "./data/site";
import { initGoogleAnalytics } from "./utils/analytics";
initGoogleAnalytics(site.googleAnalyticsId);
const rootEl = document.getElementById("root");
if (rootEl) {
  ReactDOM.createRoot(rootEl).render(<App data-id="element-133" data-mp="26a29x6dc25no" />);
}